<template>
  <table class="table table-responsive mb-2">
    <thead class="bg-grey">
      <tr>
        <th scope="col" style="width: 15%">Dose diária (%)</th>
        <th scope="col" style="width: 15%">{{ modelTitle }}</th>
        <th scope="col" style="width: 20%">Considerações técnicas</th>
        <th scope="col" style="width: 20%">Considerações técnicas atenuação</th>
        <th scope="col" style="width: 20%">Atuação recomendada</th>
        <th scope="col" style="width: 10%">Cor</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(level, levelKey) in model" :key="levelKey">
        <!-- Campos de Dose Diária -->
        <td>
          <d-form-row class="row-container">
            <span v-if="levelKey == 'level4'" class="mx-1">&gt;</span>
            <d-form-input
              class="form-control"
              v-if="level.dailyDoseMin !== undefined"
              type="text"
              v-model="level.dailyDoseMin"
              placeholder="Dose diária"
            />
            <span v-if="['level1', 'level2', 'level3'].includes(levelKey)" class="mx-1">a</span>
            <d-form-input
              class="form-control"
              v-if="level.dailyDoseMax !== undefined"
              type="text"
              v-model="level.dailyDoseMax"
              placeholder="Dose diária"
            />
          </d-form-row>
        </td>
        <!-- Campos de NHO ou NR15 -->
        <td>
          <d-form-row class="row-container">
            <span v-if="levelKey == 'level4'" class="mx-1">
              &gt;
            </span>
            <span v-if="levelKey == 'level1'" class="mx-1">até</span>

            <d-form-input
              v-if="level.min !== undefined"
              class="form-control"
              type="text"
              v-model="level.min"
              :placeholder="type.toUpperCase()"
            />

            <span v-if="['level2', 'level3'].includes(levelKey)" class="mx-1">
              a
            </span>

            <d-form-input
              v-if="level.max !== undefined"
              class="form-control"
              type="text"
              v-model="level.max"
              :placeholder="type.toUpperCase()"
            />
          </d-form-row>
        </td>
        <!-- Considerações Técnicas -->
        <td>
          <d-form-input
            class="form-control text-input"
            type="text"
            v-model="level.technicalConsiderations"
            placeholder="Considerações técnicas"
          />
        </td>
        <!-- Considerações Técnicas atenuação -->
        <td>
          <d-form-input
            class="form-control text-input"
            type="text"
            v-model="level.technicalConsiderationsAttenuation"
            placeholder="Considerações técnicas atenuação"
          />
        </td>
        <!-- Atuação Recomendada -->
        <td class="pr-3">
          <d-form-input
            class="form-control text-input"
            type="text"
            v-model="level.recommendedAction"
            placeholder="Atuação recomendada"
          />
        </td>
        <!-- Cor NHO / NR15-->
        <td class="pr-3">
          <d-input
            type="color"
            class="feColor bgColor"
            v-model="level.bgColor"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Events from '_utils/events';
import { _LOAD_MODEL_RESULTS_ } from '../SettingsModel';

export default {
  name: 'noise-result-table',
  data() {
    return {
      model: { ...this.noise },
    };
  },
  props: {
    noise: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    modelTitle() {
      return this.type.toUpperCase();
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_RESULTS_, newValue => {
      this.model = { ...newValue.noise[this.type] };
    });
  },
  watch: {
    model: {
      handler(newValue) {
        this.$emit('update:noise', newValue);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
table {
  color: #5A6169;
}

th {
  border-top: none;
  padding-left: 16px;
  color: #424242;
}

td {
  vertical-align: middle;
}

.feColor.bgColor {
  height: 37px;
  min-width: 45px;
}

.row-container {
  gap: 6px;
}

.row-container input {
  width: 65%;
  min-width: 50px;
}
</style>
